import React, { useState } from 'react';

console.log('🔄 ACCESS-REQUEST: Component loaded');

const AccessRequest = ({ organizationData, intermediateSessionToken, emailAddress, onRequestSubmitted, onError }) => {
  console.log('🔍 ACCESS-REQUEST: Rendering with org:', organizationData?.organization_name);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    console.log('🚀 ACCESS-REQUEST: Submitting access request');

    try {
      const response = await fetch(`${API_URL}/admin/users/request-access`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          organization_id: organizationData.organization_id,
          email: emailAddress,
          first_name: firstName,
          last_name: lastName,
          intermediate_session_token: intermediateSessionToken
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP ${response.status}`);
      }

      console.log('✅ ACCESS-REQUEST: Request submitted successfully');
      onRequestSubmitted(data);

    } catch (err) {
      console.error('❌ ACCESS-REQUEST: Failed:', err);
      setError(err.message || 'Failed to submit request. Please try again.');
      if (onError) {
        onError(err);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-text-primary mb-2">Request Access</h1>
          <p className="text-text-secondary">to {organizationData?.organization_name || 'Organization'}</p>
        </div>

        {/* Form Card */}
        <div className="bg-background-secondary border border-accent-lavender/30 rounded-lg p-6">
          {error && (
            <div className="mb-4 p-3 bg-red-500/10 border border-red-500/30 rounded text-red-400 text-sm">
              {error}
            </div>
          )}

          <p className="text-text-secondary mb-4 text-sm">
            Your email ({emailAddress}) matches an existing organization.
            Request access to join.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-text-primary mb-2">
                First Name
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="w-full px-3 py-2 bg-background-primary border border-accent-lavender/30 rounded text-text-primary placeholder-gray-500 focus:outline-none focus:border-accent-primary-base"
                placeholder="Enter first name"
                required
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-text-primary mb-2">
                Last Name
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="w-full px-3 py-2 bg-background-primary border border-accent-lavender/30 rounded text-text-primary placeholder-gray-500 focus:outline-none focus:border-accent-primary-base"
                placeholder="Enter last name"
                required
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-accent-primary-base text-text-inverse py-2 px-4 rounded font-medium hover:bg-accent-primary-vibrant transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Submitting...' : 'Request Access'}
            </button>
          </form>

          <p className="text-text-muted text-xs mt-4 text-center">
            An admin will review your request and send you an invitation email if approved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccessRequest;
